import { useState, useEffect } from 'react';

export const ERROR_MESSAGES = {
  PERMISSION_DENIED: 'User denied the request for Geolocation.',
  POSITION_UNAVAILABLE: 'Location information is unavailable.',
  TIMEOUT: 'The request to get user location timed out.',
  UNKNOWN_ERROR: 'An unknown error occurred.',
  FEATURE_NOT_SUPPORTED: 'Geolocation is not supported by this browser.'
};

export default function useGeolocation(requestLocation = true) {
  const [results, setResults] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const loading = !results && !errorMessage;

  const onSuccess = (position: any) => {
    setResults({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    });
  };

  const onFail = (error: any) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        setErrorMessage(ERROR_MESSAGES.PERMISSION_DENIED);
        break;
      case error.POSITION_UNAVAILABLE:
        setErrorMessage(ERROR_MESSAGES.POSITION_UNAVAILABLE);
        break;
      case error.TIMEOUT:
        setErrorMessage(ERROR_MESSAGES.TIMEOUT);
        break;
      case error.UNKNOWN_ERROR:
      default:
        setErrorMessage(ERROR_MESSAGES.UNKNOWN_ERROR);
        break;
    }
  };

  useEffect(() => {
    if (requestLocation) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(onSuccess, onFail);
      } else {
        setErrorMessage(ERROR_MESSAGES.FEATURE_NOT_SUPPORTED);
      }
    }
  }, [requestLocation]);

  return { results, errorMessage, loading };
}
